import { PIM_EMP } from '../../../router/routes'
import {
  BODY,
  BODYCLN,
  BODYCLR,
  PAGE,
  URL_WEB_V2,
  USE_IS_BETA
} from '../../../Constants'
import { useLocation, useNavigate } from 'react-router-dom'
import { BsApp } from 'react-icons/bs'
import { FaAngleDown } from 'react-icons/fa6'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useIsShowMenuListStore } from '../../../store/layout'
import { getMyTokenAPI } from '../../../services/right-menu'
function MenuMainComponent({ detail: d, isToggleMenu }) {
  const [isShowSub, setIsShowSub] = useState(false)
  const { setShowMenu: setShowOffcanvasMenu } = useIsShowMenuListStore()
  const location = useLocation()
  const pathname = location.pathname
  const navigate = useNavigate()

  useEffect(() => {
    setIsShowSub(d?.submenu.find((s) => s.link === pathname) ? true : false)
  }, [])
  const onClickMenu = () => {
    if (d.submenu.length > 0) {
      if (isToggleMenu) {
        setIsShowSub(!isShowSub)
      } else {
        const link = d.submenu[0]?.link
        if (link) {
          navigate(link)
        }
      }
    } else {
      navigate(d.link)
      setShowOffcanvasMenu(false)
    }

    if (d.link === PIM_EMP) {
      localStorage.removeItem(BODY)
      localStorage.removeItem(PAGE)
    }
    localStorage.removeItem(BODYCLN)
    localStorage.removeItem(BODYCLR)
  }

  const onClickMenuBeta = () => {
    if (d.submenu.length > 0) {
      if (isToggleMenu) {
        setIsShowSub(!isShowSub)
      } else {
        const link = d.submenu[0]?.link
        if (link) {
          getMyToken(link)
        }
      }
    } else {
      getMyToken(d.link)
    }
  }

  const chkIsMenu = (d) => {
    return pathname.split('/')[1] === d.key
  }

  const colorActive = '#2C5DFE'

  const chkIsSubMenu = (d) => {
    const path = pathname.split('/')[1] + pathname.split('/')[2]
    const link = d?.link?.split('/')[1] + d.link.split('/')[2]

    return path === link
  }

  const onClickSubMenu = (data) => {
    setShowOffcanvasMenu(false)

    if (USE_IS_BETA && data.isBeta) {
      getMyToken(data.link)
    } else {
      navigate(data.link)
    }
  }

  const getMyToken = async (link) => {
    const resp = await getMyTokenAPI()
    if (resp.status) {
      const token = resp.data
      window.open(
        `${URL_WEB_V2}/login?token=${token?.result ? token?.result?.token : ''}&go=${link}`
      )
    }
  }

  return (
    <>
      <div
        className="pointer-event mt-2"
        onClick={() => {
          if (USE_IS_BETA && d.isBeta) {
            onClickMenuBeta()
          } else {
            onClickMenu()
          }
        }}
        style={{
          color: chkIsMenu(d) ? '#fff' : 'var(--color-on-base-content-low)'
        }}
      >
        <BoxMenu
          active={chkIsMenu(d)}
          className={`${isToggleMenu ? 'justify-content-between' : 'justify-content-center'} p-1`}
          style={{
            height: '44px',
            display: 'flex',
            alignItems: 'center',
            borderRadius: '8px'
          }}
        >
          <div className="p-2">
            {d.icon ? d.icon : <BsApp size={20} />}
            {isToggleMenu ? (
              <span
                className="ms-2"
                style={{ fontWeight: 400, fontSize: '14px' }}
              >
                {d.label}
              </span>
            ) : (
              ''
            )}
          </div>
          {isToggleMenu && d.submenu.length > 0 && (
            <div className="me-2">
              {isShowSub ? (
                <FaAngleDown />
              ) : (
                <FaAngleDown style={{ transform: 'rotate(-180deg)' }} />
              )}
            </div>
          )}
        </BoxMenu>
      </div>
      <div
        style={{
          display: 'grid',
          transition: 'grid-template-rows 0.3s ease-in-out',
          gridTemplateRows: isShowSub ? '1fr' : '0fr'
        }}
      >
        <div style={{ overflow: 'hidden' }}>
          {isToggleMenu && (
            <TreeMenu>
              <ul className="tree">
                {d.submenu?.map((d, i) => (
                  <li className="pointer-event " key={i}>
                    <BoxSubMenu
                      active={chkIsSubMenu(d)}
                      className={`${isToggleMenu ? 'mt-2' : 'justify-content-center'}`}
                      style={{
                        // margin: '0px 8px',
                        cursor: 'pointer',
                        height: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '15px',
                        borderRadius: '8px'
                      }}
                      onClick={() => {
                        onClickSubMenu(d)
                      }}
                    >
                      <div
                        className={`${isToggleMenu ? 'ms-2' : 'justify-content-center'} p-1`}
                        style={{
                          fontSize: '14px',
                          color: chkIsSubMenu(d)
                            ? colorActive
                            : 'var(--color-on-base-content-low)',
                          whiteSpace: 'nowrap',
                          fontWeight: 400
                        }}
                      >
                        {/* {d.icon ? d.icon : <BsApp size={20} />} */}
                        {isToggleMenu ? (
                          <span className="">{d.label}</span>
                        ) : (
                          ''
                        )}
                      </div>
                    </BoxSubMenu>
                  </li>
                ))}
              </ul>
            </TreeMenu>
          )}
        </div>
      </div>
    </>
  )
}

const BoxMenu = styled.div`
  background-color: ${(props) => (props.active ? '#2C5DFE' : '#fff')};
  color: ${(props) =>
    props.active ? '#fff' : 'var(--color-on-base-content-low)'};
`

const BoxSubMenu = styled.div`
  background-color: ${(props) =>
    props.active ? 'var(--color-primary-foreground-subtle-pressed)' : '#fff'};
`

const TreeMenu = styled.div`
  .tree,
  .tree ul {
    margin: 0 0 0 1em; /* indentation */
    padding: 0;
    list-style: none;
    color: #e4e7ee;
    position: relative;
  }

  .tree ul {
    margin-left: 0.5em;
  }

  .tree li {
    margin: 0;
    padding: 0px 0px 0px 18px;
    line-height: 2em;
    position: relative;
  }

  .tree li:before {
    content: '';
    display: block;
    width: 14px;
    height: 60px;
    border-radius: 0px 0px 0px 10px;
    border-left: 1.5px solid #e4e7ee;
    border-bottom: 1.5px solid #e4e7ee;
    margin-top: -55px;
    position: absolute;
    top: 1em;
    left: 0px;
  }
`

export default MenuMainComponent
